/**
 * Redirect Url
 */
const redirectUrl = 'http://veeba.com.ua/?utm_source=questionary';

export { redirectUrl };
